import React from 'react';

import { DeletePhotoConfirmProps } from 'types';
import Button from 'components/Button/Button';
import icon from 'icons/delete.svg';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const DeletePhotoConfirm: React.FC<DeletePhotoConfirmProps & ComponentProps> = ({ callback, styles, closeModal }) => {
  const title = 'Delete this photo?';

  return (
    <div data-testid="delete-photo-confirm" role="dialog" aria-labelledby="photo-deletion-title">
      <img src={icon} alt="" style={{ height: '60px' }} />

      <h2 id="photo-deletion-title" className={styles.NoMargin} style={{ marginBottom: '40px' }}>
        {title}
      </h2>
      <div className={styles.ButtonRow}>
        <Button onClick={closeModal} level="low">
          <span>Cancel</span>
        </Button>
        <Button
          onClick={() => {
            callback();
            closeModal();
          }}
        >
          Delete Photo
        </Button>
      </div>
    </div>
  );
};

export default DeletePhotoConfirm;
